import {
  AccountingImporDoctolibCsvApiPayload,
  AccountingImportDoctolibCsvApiResponse,
} from '@omecare/utils';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { format, isValid, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

const importDoctolibCsv = (payload: AccountingImporDoctolibCsvApiPayload) => {
  return http.accountings.importDoctolibCsv(payload).then(({ response }) => {
    return response;
  });
};

const formatPeriodDate = (dateStr: string) => {
  const parsed = parseISO(dateStr);
  return isValid(parsed) ? format(parsed, 'dd/MM') : dateStr;
};

const useAccountingImportDoctolibCsvMutation = (): UseMutationResult<
  AccountingImportDoctolibCsvApiResponse,
  Error,
  AccountingImporDoctolibCsvApiPayload
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: importDoctolibCsv,
    onSuccess(response) {
      const workScheduleImport = response.workScheduleImport;
      const hasWorkSchedule = workScheduleImport?.saved === true;

      if (response.data.length === 0 && !hasWorkSchedule) {
        toast.warning(
          t('http.accounting-import-doctolib-csv.warning-empty-data'),
        );
      } else if (response.data.length === 0 && hasWorkSchedule) {
        toast.success(
          t('http.accounting-import-doctolib-csv.work-schedule-saved', {
            periodFrom: formatPeriodDate(workScheduleImport!.periodFrom),
            periodTo: formatPeriodDate(workScheduleImport!.periodTo),
          }),
        );
      } else {
        const message = t('http.accounting-import-doctolib-csv.success', {
          nbAccoutings: response.data.length,
        });
        if (hasWorkSchedule) {
          const workScheduleMessage = t(
            'http.accounting-import-doctolib-csv.work-schedule-saved',
            {
              periodFrom: formatPeriodDate(workScheduleImport!.periodFrom),
              periodTo: formatPeriodDate(workScheduleImport!.periodTo),
            },
          );
          toast.success(message, { description: workScheduleMessage });
        } else {
          toast.success(message);
        }
      }
    },
  });
};

export default useAccountingImportDoctolibCsvMutation;
